import {
  GET_APPOINTMENT_EXPORT_LIST,
  GET_APPOINTMENT_EXPORT_LIST_FAILURE,
  GET_APPOINTMENT_EXPORT_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getAppointmentExportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPOINTMENT_EXPORT_LIST:
      return { ...state, loading: true };
    case GET_APPOINTMENT_EXPORT_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_APPOINTMENT_EXPORT_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getAppointmentExportReducer;
